import { render, staticRenderFns } from "./AppNavbarHorizontalLayout.vue?vue&type=template&id=1ae24bf4"
import script from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js"
export * from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae24bf4')) {
      api.createRecord('1ae24bf4', component.options)
    } else {
      api.reload('1ae24bf4', component.options)
    }
    module.hot.accept("./AppNavbarHorizontalLayout.vue?vue&type=template&id=1ae24bf4", function () {
      api.rerender('1ae24bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/AppNavbarHorizontalLayout.vue"
export default component.exports